import { defineComponent } from 'vue'
import UEI from '../use/useEditInfo'
import { quickBarMethods } from '../utils/quickBar'
const keys = Object.keys(quickBarMethods)

export default defineComponent({
  name: 'JsonEditLeftMenu',
  props: {
    // 关闭编辑状态
    closeCanvas: {
      type: Function
    },
    // 组件树
    showCompTree: {
      type: Function
    }
  },
  setup(props, ctx) {
    const doSomething = (e: Event, key: string) => {
      if( key === 'closeCanvas') {
        if(confirm('即将离开编辑器，您已经保存了吗？')){
          if(props.closeCanvas) props.closeCanvas()
          // 关闭线条,关闭缩放器
          UEI.state.lineObjInfo = { x: [], y: [] }
          UEI.setClickElement(undefined)
          UEI.setClickLayout(undefined)
        }
      } else if(key === 'showCompTree') {
        if(props.showCompTree) props.showCompTree()
      } else if (key === 'clearCanvas') {
        ;(quickBarMethods as any)[key]()
      } else if (key === 'downloadJson' || key === 'eyeLayoutDetail' || key === 'editLayout') {
        if (UEI.state.clickLayout) {
          ;(quickBarMethods as any)[key]()
        }
      } else if (key === 'downloadApidataJson' || key === 'eyeApidataDetail' || key === 'editApidata') {
        if (UEI.state.mockData) {
          ;(quickBarMethods as any)[key]()
        }
      } else {
        if (UEI.state.clickLayout && UEI.clickElement) {
          ;(quickBarMethods as any)[key]()
        }
      }
    }
    return () => {
      return (
        <div class="top-bar">
          {keys && keys.length
            ? keys.map(key => {
                const tempItem = (quickBarMethods as any)[key].config
                return (
                  <div class="top-bar-item" title={tempItem?.title} {...{ onClick: e => doSomething(e, key) }}>
                    {tempItem ? <i class={`k-icon icon-${tempItem?.icon}`} />: null}
                    {tempItem?.text}
                  </div>
                )
              })
            : null}
        </div>
      )
    }
  }
})
